import { settlementLessonSchedule, settlementLessonTypeLabel } from './teacherSettlementGroups';

const formatPayrollAmount = (value, language = 'pl') => new Intl.NumberFormat(language === 'en' ? 'en-GB' : 'pl-PL', {
  style: 'currency',
  currency: 'PLN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format(value);

export default formatPayrollAmount;


export const hasPayrollAlerts = report => !report.verification || Boolean(report.verification.missingAttendanceCount > 0 || report.issue ||
  (report.warnings || []).length || report.verification.requiresRecalculation || (report.verification.problems || []).length);

const normalizedSearch = value => String(value || '').toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/ł/g, 'l');

export function settlementMatchesSearch(report, query, t) {
  const terms = normalizedSearch(query).trim().split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const text = normalizedSearch([report.teacherName, ...(report.lessonView || []).flatMap(lesson => {
    const schedule = settlementLessonSchedule(lesson);
    const classSchedule = lesson.classSchedule || {};
    return [settlementLessonTypeLabel(lesson.classTypeId, t), t(`weekdays.${schedule.dayOfWeek || 'unknown'}`),
      classSchedule.dayOfWeek ? t(`weekdays.${classSchedule.dayOfWeek}`) : '',
      schedule.actualDayOfWeek ? t(`weekdays.${schedule.actualDayOfWeek}`) : '',
      classSchedule.startTime, schedule.startTime, lesson.startTime, ...(lesson.participants || []).map(student => student.label)];
  })].join(' '));
  return terms.every(term => text.includes(term));
}
